import React, { useState } from 'react';
import {
  RemoveAlertDialog,
  useDisclosure,
  VStack,
} from '@wegroup/design-system';
import AddInsuranceModalNavigationCoverages from './AddInsuranceModalNavigationCoverages';
import { Coverage } from '../../../../../../../types/AdvisoryReport';
import { Page } from '../../../hooks/useInsurancePolicyModal';
import useAddInsuranceModalContext from '../../../hooks/useAddInsuranceModalContext';
import { useTranslation } from 'react-i18next';

interface Props {
  page: Page;
  coverages: Coverage[];
  onPageChange: (page: Page) => void;
  onRemove: (ids: string[]) => void;
}

const AddInsuranceModalNavigation: React.FC<Props> = ({
  coverages,
  page,
  onPageChange,
  onRemove,
}) => {
  const { t } = useTranslation();
  const [pageToGoTo, setPageToGoTo] = useState<Page>();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { isCoverageEditOpen, setIsCoverageEditOpen } =
    useAddInsuranceModalContext();

  const handleChangePage = (index: number) => {
    if (isCoverageEditOpen) {
      setPageToGoTo({ type: 'COVERAGE', index: index });
      onOpen();
    } else {
      setIsCoverageEditOpen.off();
      onPageChange({ type: 'COVERAGE', index: index });
    }
  };
  return (
    <VStack
      spacing="6"
      p="6"
      bg="gray.ultraLight"
      borderRight="1px"
      borderColor="gray.50"
      align="stretch"
      textStyle="normalBody"
    >
      <RemoveAlertDialog
        title={t('ARE-YOU-SURE')}
        description={t(
          'ADVISORY-REPORTS_CREATION-FLOW_CURRENT-INSURANCE_MODAL_EDITING-ALERT',
        )}
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={() => onPageChange(pageToGoTo!)}
      />
      {/* COVERAGES */}
      <AddInsuranceModalNavigationCoverages
        coverages={coverages}
        page={page}
        onClick={handleChangePage}
        onRemove={onRemove}
      />
    </VStack>
  );
};

export default AddInsuranceModalNavigation;
